import React from 'react';

import type { KeyValue } from '../../../../../../Shared/js/@types/KeyValue';
import type { SpeedRange } from '../../home/SpeedDataSelect';
import SpeedDataSelect from '../../home/SpeedDataSelect';

interface Props {
    current: number;
    anyLabel: string;
    fromLabel: string;
    values: KeyValue[];
    speedRanges?: SpeedRange[];
    speedLabel: string;
    onValueChanged: (value: number | { min: number; max: number }) => void;
}

const ModalSpeedSlider = (props: Props) => {
    /* const getLabel = useCallback(
        (labelText: string | JSX.Element) => <strong className="font-5">{labelText}</strong>,
        []
    ); */
    return (
        <SpeedDataSelect
            isModal={true}
            primaryFilterAsSpeed={true}
            speedDescription={props.speedLabel}
            speedRanges={props.speedRanges || []}
            speed={props.current}
            onSpeedChange={props.onValueChanged}
            speedFormat={'Mbps'}
            className="dropdown bootstrap-select show-tick bs3"
            dataWidth="100%"
        />
    );
};

export default ModalSpeedSlider;
